export default {

    data() {

        var self = this;

        return {

            rules: {
                required: v => !!v || this.$t('GLOBAL-FORM-FIELD_REQUIRED'),
                length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
                minPassword(min, v) {
                    return (v || '').length >= min || "Minimum "+min+" Chars";
                },
                name: v => v && v.length >= 3 || this.$t('GLOBAL-FORM-MIN_LENGTH_NAME'),
                email: v => /.+@.+\..+/.test(v) || this.$t('GLOBAL-FORM-EMAIL_NOT_VALID'),
            },
        }
    },

    mounted() {

    },

    computed: {

        currentUser() {
            return this.$store.getters.currentUser;
        },

    },

    filters: {


    },


    methods: {

        nl2br(text) {

            if(typeof text == 'undefined' || text == "" || text == null) {
                return text;
            }

            return text.replace(/(?:\r\n|\r|\n)/g, '<br />');

        },

        formatPoint2Comma(val, decimals=false) {

            if(val == null || val == "" || typeof val === "undefined") {
                return 0;
            }

            let number = decimals != false ? (val*1).toFixed(decimals) : val;
            return number.toString().replace(".", ",");

        },

        fileExists(urlToFile) {

            var xhr = new XMLHttpRequest();

            xhr.open('HEAD', urlToFile, false);
            xhr.send();

            return xhr.status == "404" ? false : true;

        },


        dateFormat(date, options={}) {

            let defaultOptions = {
                'showDaysOnly': false,
                'separateTime': false
            }

            for(let key in defaultOptions) {
                if(typeof options[key] == 'undefined') {
                    options[key] = defaultOptions[key];
                }
            }

            let givenDate = new Date(date);
            let now = new Date();

            // var locale = "en-us";
            let locale = 'de-DE';

            // calculate the time difference of the two dates
            let secondsPast = (now.getTime() - givenDate.getTime() ) / 1000;

            // SECONDS only
            if(secondsPast < 60) {

                if(secondsPast == 1) {
                    return 'vor ' + parseInt(secondsPast) + ' Sekunde';
                }
                return 'vor ' + parseInt(secondsPast) + ' Sekunden';

            }

            // MINUTES only
            if(secondsPast < 3600) {

                if(secondsPast <= 60) {
                    return 'vor ' + parseInt(secondsPast/60) + ' Minute';
                }
                return 'vor ' + parseInt(secondsPast/60) + ' Minuten';

            }

            // HOURS only
            if(secondsPast <= 86400) {

                if(secondsPast <= 3600) {
                    return 'vor ' + parseInt(secondsPast/3600) + ' Stunde';
                }
                else if(secondsPast > 3600 && secondsPast < 7200 ) {
                    return 'vor über ' + parseInt(secondsPast/3600) + ' Stunde';
                }
                return 'vor ' + parseInt(secondsPast/3600) + ' Stunden';

            }

            // ELSE
            if(secondsPast > 86400) {

                var hours = this.addZero(givenDate.getHours());
                var minutes = this.addZero(givenDate.getMinutes());

                // just yesterday
                if(secondsPast > 86400 && secondsPast <= 172800) {
                    return 'gestern um ' + hours + ':' + minutes;
                }


                // show days only
                if(options.showDaysOnly) {

                    let daysPast = parseInt(secondsPast / (3600 * 24));
                    return 'vor ' + daysPast + ' Tagen';

                } else {

                    var day = givenDate.getDate();

                    // show month in long version (localized)
                    var month = givenDate.toLocaleString(locale, { month: "long" });

                    // only show year if not current year
                    var year = givenDate.getFullYear() == now.getFullYear() ? "" :  " " + givenDate.getFullYear();

                    if(options.separateTime == true) {
                        return day + "." + month + year + '<br /><span class="is-size-7">' + hours + ':' + minutes + ' Uhr</span>';
                    } else {
                        return day + "." + month + year + ' um ' + hours + ':' + minutes;
                    }

                }

            }

        },
        addZero(i) {

            if (i < 10) {
                i = "0" + i;
            }

            return i;

        },

    }

}
